<template>
    <div class="c-zn-forms-filter-dropdown c-zn-form-filtercat">
        <button @click="toggle = !toggle" class="c-zn-forms-sidebar__label c-zn-forms-filter-dropdown__button" :class="toggle ? 'is-active' : ''">
            {{ label }}
            <svg class="icon icon-next-arrow"><use xlink:href="#icon-next-arrow"></use></svg>
        </button>
        <div class="c-zn-forms-filter-dropdown__list" :class="toggle ? 'is-active' : ''">
            <div class="c-zn-form-filter__mobile-header">
                <button @click="toggle = false" class="c-zn-form-filter-dropdown__back">
                    <svg class="icon icon-back-arrow"><use xlink:href="#icon-back-arrow"></use></svg>
                </button>
                {{ label }}
                <button @click="$emit('close')" class="c-zn-form-filter__mobile__close">
                    <svg class="icon icon-icon_close_dark"><use xlink:href="#icon-icon_close_dark"></use></svg>
                </button>
            </div>
            <div class="c-zn-forms-filter-dropdown__options">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
    },
    mounted() {
        window.addEventListener('resize', () => {
            if (window.innerWidth <= 768) {
                this.toggle = false;
            } else {
                this.toggle = true;
            }
        });
    },
    data() {
        return {
            toggle: window.innerWidth > 768,
        }
    }
}
</script>